import {Pipe, PipeTransform} from '@angular/core';
import {environment} from "../../../environments/environment";

@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  public currency: Record<string, string> = {
    'HLTV': '$',
    'CSGOFAST': '',
  }
  public sign = this.currency[environment.projectName];

  transform(value: any): string {
    return this.sign + ' ' + value;
  }
}
